import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-bcee23bc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "checkbox-wrapper" }

interface Props {
  modelValue?: boolean;
  label?: string;
  disabled?: boolean;
}
interface Emits {
  (type: 'update:modelValue', e: boolean): void;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'Checkbox',
  props: {
    modelValue: { type: Boolean, default: false },
    label: { default: '' },
    disabled: { type: Boolean, default: false }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit }: { emit: ({
  (type: 'update:modelValue', e: boolean): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { modelValue: boolean, label: string, disabled: boolean }





function toggleValue() {
  !props.disabled && emit('update:modelValue', !props.modelValue);
}

return (_ctx: any,_cache: any) => {
  const _component_FontAwesomeIcon = _resolveComponent("FontAwesomeIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["checkbox", { disabled: __props.disabled }]),
      onClick: toggleValue
    }, [
      (__props.modelValue)
        ? (_openBlock(), _createBlock(_component_FontAwesomeIcon, {
            key: 0,
            icon: "check"
          }))
        : _createCommentVNode("", true)
    ], 2),
    (__props.label)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "label",
          onClick: toggleValue
        }, _toDisplayString(__props.label), 1))
      : _createCommentVNode("", true)
  ]))
}
}

})